import { render, staticRenderFns } from "./moduleDetail.vue?vue&type=template&id=6b36b456&"
import script from "./moduleDetail.vue?vue&type=script&lang=ts&"
export * from "./moduleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./moduleDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports